import React from 'react';
import { connect } from 'react-redux';
import Icon from '@ant-design/icons';
import Modal from 'antd/lib/modal';
import { TrashIcon } from 'icons';

import CVATTooltip from 'components/common/cvat-tooltip';
import {
    removeAnnotationsAsync as removeAnnotationsAsyncAction,
} from 'actions/annotation-actions';

export interface StateToProps {
    frameNumber: number;
}

interface DispatchToProps {
    removeAnnotations(frameNumber: number): void;
}

function mapDispatchToProps(dispatch: any): DispatchToProps {
    return {
        removeAnnotations(frameNumber: number) {
            dispatch(removeAnnotationsAsyncAction(frameNumber, frameNumber, false));
        },
    };
}

type Props = StateToProps & DispatchToProps;

function RemoveFrameAnnotationsControl(props: Props): JSX.Element {
    const { frameNumber, removeAnnotations } = props;
    return (
        <CVATTooltip title='移除当前帧上的所有标注' placement='right'>
            <Icon
                component={TrashIcon}
                onClick={() => {
                    Modal.confirm({
                        title: '移除当前帧上的所有标注',
                        content: '您是否想移除当前帧上的所有标注？操作不可回退，请务必谨慎执行！',
                        okText: '继续',
                        cancelText: '取消',
                        className: 'cvat-modal-content-finish-job',
                        onOk: () => {
                            removeAnnotations(frameNumber);
                        },
                    });
                }}
            />
        </CVATTooltip>
    );
}

export default connect(null, mapDispatchToProps)(RemoveFrameAnnotationsControl);
